import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';

import SearchBtn from './Search_Btn';
import UserAvatarBtn from './User_Avatar_Btn';
import LanguageBtn from './Language_btn';

import MenuIcon from '@mui/icons-material/Menu';
import { GrNotification } from 'react-icons/gr';

import { useSelector, useDispatch } from 'react-redux';
import { dashboardActions } from '../../Redux/Dashboard_Slice';

const Navbar = () => {
  const dashboard = useSelector((state) => state.dashboard);
  const dispatch = useDispatch();

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 1);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AppBar
      position="fixed"
      sx={{
        transition: 'background-color 0.3s ease, backdrop-filter 0.3s ease',
        backdropFilter: scrolled ? 'blur(2px)' : 'none',
        backgroundColor: scrolled ? "transparent" : 'rgba(255, 255, 255, 0.85)',
        width: { lg: `calc(100% - ${dashboard.drawerWidth}px - 50px)` },
        ml: { lg: `${dashboard.drawerWidth}px` },
        mt: { lg: '20px' },
        mr: { lg: '20px' },
        color: 'black',
        boxShadow: scrolled ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
        border: scrolled ? '1px solid #e0e0e0' : 'none',
        borderRadius: '12px',
        height: '64px',
      }}
    >
      <Toolbar sx={{ height: '100%', justifyContent: 'space-between' }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={() => dispatch(dashboardActions.handleDrawerToggle())}
          sx={{ mr: 2, display: { lg: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Box
          sx={{
            display: 'flex',
            gap: '15px',
            width: '100%',
            height: '100%',
            alignItems: 'center'
          }}
        >
          <SearchBtn />
          <IconButton sx={{ display: { md: 'flex', xs: 'none' } }}>
            <GrNotification color="#CD9D41" size={26} />
          </IconButton>
        </Box>
        
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
